<template>
  <div class="clearfix">
    <div class="float-start">
      <div class="mc-table-filter__status pb-4">
        <McButton
          :variant="filterStatus.all ? 'secondary' : 'outline'"
          size="sm"
          class="me-2"
          @click="updateFilterStatus('all')"
          :text="$t('master.status.all')"
        />
        <McButton
          :variant="filterStatus.active ? 'secondary' : 'outline'"
          size="sm"
          class="me-2"
          @click="updateFilterStatus('active')"
          :text="$t('master.status.aktif')"
        />
        <McButton
          :variant="filterStatus.archive ? 'secondary' : 'outline'"
          size="sm"
          class="me-2"
          @click="updateFilterStatus('archive')"
          :text="$t('master.status.arsip')"
        />
      </div>
      <h6 v-if="selectedIdsLength" class="mc-row-check">
        <span class="badge btn-success">{{ selectedIdsLength }}</span>
        {{ $t('global.object.selectedRow') }}
        <a class="color-primary" @click="handleUnselectAll"> {{ $t('global.action.clearAll') }}</a>
      </h6>
    </div>
    <!-- Search -->
    <div class="float-end">
      <div class="mc-table-view">
        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
          <label
            class="d-inline-flex align-items-center mc-table-view__search ms-2"
            @click="focusSearch"
          >
            <i class="mc-fa fas fa-search"></i>
            <b-form-input
              ref="searchInput"
              type="search"
              :placeholder="$t('global.search') + '...'"
              :value="search"
              class="ms-2"
              @input="handleSearchChange"
            />
          </label>
        </div>
      </div>
    </div>
    <!-- End search -->
  </div>
</template>

<script>
import McButton from '@/components/McButton'
export default {
  name: 'SearchAndFilter',
  components: {
    McButton,
  },
  props: {
    filterStatus: {
      type: Object,
      default: () => ({
        all: true,
        active: false,
        archive: false,
      }),
    },
    search: {
      type: String,
      default: '',
    },
    selectedIdsLength: {
      type: Number,
      default: 0,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    handleSearchChange: {
      type: Function,
      default: () => {},
    },
    handleUnselectAll: {
      type: Function,
      default: () => {},
    },
    updateFilterStatus: {
      type: Function,
      default: () => {},
    },
  },

  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
  },
}
</script>
